import { openDeviceDatabase, ROUTE_CACHE_STORE } from "./device-storage";
import type { CloudRoute } from "./route-workflow";

export async function savePublishedRouteCache(routes: CloudRoute[]) {
  if (!("indexedDB" in window)) return;
  const database = await openDeviceDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(ROUTE_CACHE_STORE, "readwrite");
    const store = transaction.objectStore(ROUTE_CACHE_STORE);
    routes.forEach((route) => store.put(route));
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
  database.close();
}

export async function loadPublishedRouteCache() {
  if (!("indexedDB" in window)) return [];
  const database = await openDeviceDatabase();
  const result = await new Promise<CloudRoute[]>((resolve, reject) => {
    const request = database.transaction(ROUTE_CACHE_STORE, "readonly").objectStore(ROUTE_CACHE_STORE).getAll();
    request.onsuccess = () => resolve(request.result as CloudRoute[]);
    request.onerror = () => reject(request.error);
  });
  database.close();
  return result;
}
